function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import omit from "lodash.omit";
import ContextMenuItem from "../Context/ContextMenuItem";
import DropdownReactContext from "./DropdownReactContext";
export default class DropdownMenuItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    const {
      closeDropdown
    } = this.context;
    const {
      multiSelect,
      keepOpen,
      onClick
    } = this.props;
    if (closeDropdown && !multiSelect && !keepOpen) closeDropdown();
    if (onClick) onClick(event);
  }

  render() {
    const {
      children,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(ContextMenuItem, _extends({}, omit(rest, ["keepOpen"]), {
      onClick: this.handleClick,
      tabIndex: "0"
    }), children);
  }

}

_defineProperty(DropdownMenuItem, "contextType", DropdownReactContext);